import Modal from "/WebInterface/new-ui/modules/modal.js";
import DragDrop from "/WebInterface/new-ui/modules/drag-and-drop/drag-and-drop.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import fileArrangementTemplate, {
  arrangementCardTemplate,
} from "./template.js";
import store from "/WebInterface/new-ui/store/index.js";
import { defaultFileListingColumnsOrder } from "/WebInterface/new-ui/assets/js/constants.js";

export const initListingColumnArrangement = () => {
  const renderfileListingTableColumnArrangemnt = (setDefault) => {
    const columnsArrangement = setDefault
      ? defaultFileListingColumnsOrder
      : JSON.parse(
          localStorage.getItem("file-listing-table-columns-arrangement")
        ) || defaultFileListingColumnsOrder;

    const fileListingTableColumnArrangemnt = [];
    Object.entries(columnsArrangement).forEach(([key, value]) => {
      const order = value?.order;
      fileListingTableColumnArrangemnt[order] = { column_name: key };
    });

    const wrapper = _$("#listingTableArrangement .table-column-arrangement");

    wrapper.html("");

    fileListingTableColumnArrangemnt.forEach(({ column_name }) => {
      wrapper.el().insertAdjacentHTML(
        "beforeend",
        arrangementCardTemplate({
          transfer_value: column_name,
          label: t(column_name),
          i18n_key: column_name,
        })
      );
    });

    new DragDrop({
      draggable: _$("#listingTableArrangement .arrangement-card").sel(),
      droppable: _$("#listingTableArrangement .arrangement-card").sel(),
      generateTooltip: (elem) => {
        return elem.outerHTML;
      },
      onDragStart: (evt, target) => {
        const dt = evt.dataTransfer;
        dt.effectAllowed = "move";
        dt.dropEffect = "move";
        dt.setData("text/plain", _$(target).attr("data-transfer-value"));
      },
      onDrop: (evt, target) => {
        const transferValue = evt.dataTransfer.getData("text/plain");
        const draggedColumn = _$(
          `#listingTableArrangement [data-transfer-value='${transferValue}']`
        );

        const { top: draggedColumnTop } = draggedColumn
          .el()
          .getBoundingClientRect();

        const { top: targetedColumnTop } = target.getBoundingClientRect();

        if (targetedColumnTop < draggedColumnTop) {
          target.insertAdjacentElement("beforebegin", draggedColumn.el());
        } else {
          target.insertAdjacentElement("afterend", draggedColumn.el());
        }

        _$(evt.currentTarget).removeClass("dragged-on");
      },
      onDragOver: (evt, target) => {
        _$(evt.currentTarget).addClass("dragged-on");
      },
      onDragLeave: (evt, target) => {
        _$(evt.currentTarget).removeClass("dragged-on");
      },
    });
  };

  // Modal
  new Modal({
    title: "arrangeFileListingTableColumns",
    body: fileArrangementTemplate({}),
    uniqueId: "column-arrangement-modal",
    buttons: [
      {
        label: "setToDefault",
        close: false,
        classes: ["secondary-button", "mr-3"],
        onClick: () => {
          renderfileListingTableColumnArrangemnt(true);
        },
      },
      {
        label: "save",
        close: true,
        classes: ["primary-button", "mr-3"],
        onClick: async () => {
          const cards = _$("#listingTableArrangement .arrangement-card").sel();

          const _arrangement =
            JSON.parse(
              localStorage.getItem("file-listing-table-columns-arrangement")
            ) || defaultFileListingColumnsOrder;

          cards.forEach((card, index) => {
            const column_name = _$(card).attr("data-transfer-value");
            _arrangement[column_name] = {
              ..._arrangement[column_name],
              order: index,
            };
          });

          localStorage.setItem(
            "file-listing-table-columns-arrangement",
            JSON.stringify(_arrangement)
          );

          store.dispatch("setFileListing", store.files);
        },
      },
    ],
  });

  renderfileListingTableColumnArrangemnt();
};
